// Events page is commented out in index.js, header.js and landing.js becuase there are no events
import '../style/main.css';
import Meta from '../components/Meta.js';
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import Event from '../components/Event.js';
import eventImage from '../resources/test-banner.png';

function Events() {
  return (
		<>
			<Meta title='Events' />
			<Header />
			<div class='main-content'>
				<h2>Events</h2>

				<Event 
					image={eventImage}
					title='Test Event'
					date='07-14-2025'
					time='12:00 PM'
					location='61 Lester River Rd, Duluth, MN 55804'
					locationURL='https://www.youtube.com/watch?v=xiWuxHO417M'
					description={<div>
						<p>
							Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. 
							In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla 
							lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. 
							Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.
							<br /><br />
							Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. 
							In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla 
							lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. 
							Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.
							<br /><br />
							Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. 
							In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla 
							lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. 
							Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.
							<br /><br />
							Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. 
							In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla 
							lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. 
							Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.
							<br /><br />
							Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. 
							In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla 
							lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. 
							Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.
						</p>
						<br />
						<p>
							<b>Parking</b>
							<br />
							Lester has a sizable parking lot, with one overflow lot up the road north. 
						</p>
						<br/>
						<p>
							<b>Schedule</b>
							<br/>
							12:00PM: Event Kick-off
							<br/>
							12:30PM: Dueling in the park
							<br/>
							02:00PM: Lunch break
							<br/>
							03:00PM: Longsword Tournament
						</p>
					</div>}
					contact='borealisblades@gmail.com'
				/>
			</div>
			<Footer />  
		</>
	);
};

export default Events;
